import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import classes from "./ReportPage.module.css"
import plus from "../../../Assets/plus.svg"
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import ReportBackground from "../../../Assets/report.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import logo from "../../../Assets/rotating-logo.png";
import DocLogo from "../../../Assets/doc.svg";
import ArrowRpt from "../../../Assets/report-arrow.svg";
import SettingsRpt from "../../../Assets/rpt-settings.svg";
import Cal from "../../../Assets/cal.svg";
import profitAndLossImg from "../../../Assets/profit.svg";
import balanceSheetImg from "../../../Assets/bal.svg";
import cashflowimg from "../../../Assets/cash.svg";
import trialBal from "../../../Assets/trial.svg";
import { BASE_URL } from "../../../Components/Styles/API/API";








const ReportPage = () => {
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [address, setAddress] = useState("");
  const [office_address, setOfficeAddress] = useState("");
  const [accName, setAccName] = useState('');
  const [accNo, setAccNo] = useState('');
  const [bankName, setBankName] = useState('');
  const [accName1, setAccName1] = useState('');
  const [accNo1, setAccNo1] = useState('');
  const [bankName1, setBankName1] = useState('');
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [searchedResult, setSearchedResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [editCustomer, setEditCustomer] = useState(null);

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);

  const handleShowEdit = (customer) => {
    setEditCustomer(customer); // load selected customer
    setShowEdit(true);
  };

  const handleCloseEdit = () => {
    setShowEdit(false);
    setEditCustomer(null);
  };
  const handleShow = () => setShow(true);
  const handleShow2 = (customer) => {
    setSelectedCustomer(customer); // save selected customer
    setShow2(true); // open modal
  };
  const handleShow1 = () => setShow1(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const fetchSearch = async (searchTerm) => {
    setSearchLoading(true);
    try {
      let res;
      if (searchTerm.trim() === "") {
        res = tableData;
      } else {
        const response = await axios.get(`${BASE_URL}/customer/search`, {
          params: { variable: searchTerm },
          headers
        });
        res = response.data?.data;
      }
      setSearchedResult(res);
      console.log(res, "searched");

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setSearchedResult([]);
      }
    } finally {
      setSearchLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm.trim() !== "") {
        fetchSearch(searchTerm);
      } else {
        setSearchedResult([]); // clear results if empty
      }
    }, 500); // 500ms debounce

    return () => {
      clearTimeout(handler); // cancel on new keystroke
    };
  }, [searchTerm]);

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;

  const createCustomer = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to create this customer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Create",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true); // show rotating logo overlay
        try {
          const response = await axios.post(
            `${BASE_URL}/customer/add`,
            {
              name: fullName,
              email: email,
              phone: phone,
              address: address,
              office_address: office_address,
              account_name: accName,
              account_number: accNo,
              bank_name: bankName,
            },
            { headers }
          );

          handleCustomers();
          handleClose();

          Swal.fire({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }

          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false); // hide rotating logo
        }
      }
    });
  };

  const uploadExcel = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to upload this document?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Upload",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUploading(true);
        try {
          const formData = new FormData();
          formData.append('file', selectedFile[0]);


          const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`,
          };


          const response = await axios.post(`${BASE_URL}/customer/import-customer?category_id=${1}`,
            formData,
            { headers }
          );
          handleClose1();
          handleCustomers();
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.data.message,
          });

          console.log(response.data.message);
        } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }

          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: errorMessage,
          });

          console.error(error);
        } finally {
          setUploading(false);
        }
      }
    });
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    const fileList = Array.from(files);
    setSelectedFile(fileList);

  };

  const updateCustomer = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this customer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Update",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);

        try {
          const response = await axios.post(`${BASE_URL}/admin/users/update`,
            {
              name: fullName1,
              id: editCustomer.id,
              email: email1,
              phone: phone1,
              account_name: accName1,
              account_number: accNo1,
              bank_name: bankName1,

            },
            { headers }
          );

          handleCustomers();
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.data.message,
          });

          // console.log(response.data);
        } catch (error) {
          let errorMessage = "Something went wrong.";
          if (error.response && error.response.data.message) {
            errorMessage =
              typeof error.response.data.message === "string"
                ? error.response.data.message
                : JSON.stringify(error.response.data.message);
          }

          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: errorMessage,
          });

          console.error(error);
        } finally {
          setLoading(false);
        }
      }
    });
  };

// Financial Reports
const financialReports = [
  { title: "Cashbook", description: "Track cash inflows and outflows", icon: profitAndLossImg, path: "/accounting/print_cashbook" },
  { title: "Trial Balance", description: "Verify debit and credit balances", icon: balanceSheetImg, path: "/accounting/trial_balance" },
  { title: "Income Statement - Summary", description: "Summarized profit & loss", icon: cashflowimg, path: "/accounting/print_income_statement" },
  { title: "Income Statement - Detailed", description: "Detailed profit & loss", icon: profitAndLossImg, path: "/accounting/print_income_statement_detailed" },
  { title: "Account Activity Report", description: "Transactions & account activity", icon: cashflowimg, path: "/accounting/print_activity_report_acct" },
 { title: " Account Activity Report - Category", description: "Transactions & account activity", icon: cashflowimg, path: "/accounting/print_activity_report_category" },
  { title: "Statement of Financial Position - Summary", description: "Assets, liabilities & equity summary", icon: profitAndLossImg, path: "/financial_position" },
  { title: "Statement of Financial Position - Detailed", description: "Detailed balance sheet report", icon: trialBal, path: "/accounting/statement_of_financial_position" },
  { title: "Bank Position Summary", description: "Overview of bank accounts", icon: cashflowimg, path: "/accounting/bank_report" },
  
];

// Sales & Customer Reports
const salesReports = [
  { title: "Sales Report", description: "Overview of sales transactions", icon: cashflowimg, path: "/accounting/sales_report" },
  { title: "Age Analysis - Receivables", description: "Outstanding customer balances", icon: profitAndLossImg, path: "/accounting/aged_analysis_receivables" },
  { title: "Schedule of Loan Receivables", description: "Overview of loan receivables", icon: cashflowimg, path: "/accounting/print_loan_receivables" },
  { title: "Outstanding Remittances", description: "Overview of outstanding remittances", icon: cashflowimg, path: "/accounting/print_outstanding_remittances" },
  // { title: "Schedule of Receivables", description: "Overview of receivables", icon: cashflowimg, path: "/accounting/print_loan_receivables" },
];

// Purchase & Supplier Reports
const purchaseReports = [
  { title: "Purchases Report", description: "Overview of purchases transactions", icon: balanceSheetImg, path: "/accounting/purchase_report" },
  { title: "Age Analysis - Payables", description: "Outstanding supplier balances", icon: trialBal, path: "/accounting/aged_analysis_payables" },
  { title: "Schedule of Payables", description: "Overview of payables", icon: cashflowimg, path: "/accounting/schedule_of_payable" },
];



  return (
    <div >
      <HeaderNav />

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>Add Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form >
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Full Name"
                // autoFocus
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Address"
                // autoFocus
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Office Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter office Address"
                // autoFocus
                value={office_address}
                onChange={(e) => setOfficeAddress(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Phone Number"
                // autoFocus
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Email Address"
                // autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Account Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Account Name"
                // autoFocus
                value={accName}
                onChange={(e) => setAccName(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Account Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Account Number"
                // autoFocus
                value={accNo}
                onChange={(e) => setAccNo(e.target.value)}
              />
              <div style={{ marginTop: 10 }} />
              <Form.Label>Bank Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Bank Name"
                // autoFocus
                value={bankName}
                onChange={(e) => setBankName(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>






        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Go back
          </Button>
          <Button className={classes.loanBtn} variant="primary" onClick={createCustomer}>
            Create Customer
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show1} style={{ fontSize: 18, fontWeight: 600 }} onHide={handleClose1} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ fontSize: 14 }}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Excel File</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx, .xls, .csv"
                onChange={handleFileChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>







        <Modal.Footer>
          <Button variant="danger" onClick={handleClose1}>
            Go back
          </Button>
          <Button className={classes.loanBtn} variant="primary" onClick={uploadExcel}>


            Upload

          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>View User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCustomer ? (
            <Form style={{ fontSize: 14 }}>
              <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedCustomer.name || ""}
                  readOnly
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedCustomer.email || ""}
                  readOnly
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedCustomer.phone || ""}
                  readOnly
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedCustomer.address || ""}
                  readOnly
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Office Address</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedCustomer.office_address || ""}
                  readOnly
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Bank Details</Form.Label>
                <Form.Control
                  type="text"
                  value={`${selectedCustomer.account_name || ""} - ${selectedCustomer.account_number || ""} (${selectedCustomer.bank_name || ""})`}
                  readOnly
                />
              </Form.Group>
            </Form>
          ) : (
            <p>No customer selected</p>
          )}
        </Modal.Body>
      </Modal>
      <Modal show={showEdit} onHide={handleCloseEdit} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>
            Edit Customer
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editCustomer && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={editCustomer.name}
                  onChange={(e) =>
                    setEditCustomer({ ...editCustomer, name: e.target.value })
                  }
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  value={editCustomer.address}
                  onChange={(e) =>
                    setEditCustomer({ ...editCustomer, address: e.target.value })
                  }
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Office Address</Form.Label>
                <Form.Control
                  type="text"
                  value={editCustomer.office_address}
                  onChange={(e) =>
                    setEditCustomer({ ...editCustomer, office_address: e.target.value })
                  }
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  value={editCustomer.phone}
                  onChange={(e) =>
                    setEditCustomer({ ...editCustomer, phone: e.target.value })
                  }
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="text"
                  value={editCustomer.email}
                  onChange={(e) =>
                    setEditCustomer({ ...editCustomer, email: e.target.value })
                  }
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Account Name</Form.Label>
                <Form.Control
                  type="text"
                  value={editCustomer.account_name}
                  onChange={(e) =>
                    setEditCustomer({ ...editCustomer, account_name: e.target.value })
                  }
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  type="text"
                  value={editCustomer.account_number}
                  onChange={(e) =>
                    setEditCustomer({ ...editCustomer, account_number: e.target.value })
                  }
                />
                <div style={{ marginTop: 10 }} />

                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  type="text"
                  value={editCustomer.bank_name}
                  onChange={(e) =>
                    setEditCustomer({ ...editCustomer, bank_name: e.target.value })
                  }
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseEdit}>
            Cancel
          </Button>
          <Button
            className={classes.loanBtn}
            variant="primary"
            onClick={() => updateCustomer(editCustomer)}
          >
            Update Customer
          </Button>
        </Modal.Footer>
      </Modal>


      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <div
          className={classes.rptBck}
          style={{ backgroundImage: `url(${ReportBackground})` }}
        >
          <div className={classes.rptInn}>
            <div className={classes.rptCont}>
              <p className={classes.rptHd}>Business Reports</p>
              <p className={classes.rptSb}>
                Generate comprehensive financial and business insights
              </p>
            </div>
            <div className={classes.rptCont}>
              <p className={classes.rptHds}>28</p>
              <p className={classes.rptSbs}>Reports this month</p>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 27 }} />
        <div className={classes.cardContainer}>
          {[
            {
              label: "Available Reports",
              labelColor: '#3B82F6',
              value: "24",
              topIcon: DocLogo,
              bottomText: "Ready to generate",
              bottomColor: "#092147B2" // green
            },
            {
              label: "Generated This Month",
              value: "21",
              topIcon: ArrowRpt,
              labelColor: '#092147',
              bottomText: "+15% from last month",
              bottomColor: "#092147B2"
            },
            {
              label: "Custom Reports",
              value: "3",
              topIcon: SettingsRpt,
              bottomText: "User created",
              labelColor: '#EAB308',
              bottomColor: "#092147B2" // red
            },
            {
              label: "Scheduled Reports",
              value: "5",
              topIcon: Cal,
              bottomText: "Auto-generated",
              labelColor: '#A855F7',
              bottomColor: "#092147B2" // blue
            },

          ].map((item, idx) => (
            <div className={classes.statCard} key={idx}>
              {/* top row */}
              <div className={classes.cardHeader}>
                <p className={classes.cardLabel}>{item.label}</p>
                <img src={item.topIcon} alt="" className={classes.cardTopIcon} />
              </div>

              {/* value */}
              <h3 className={classes.cardValue}><span style={{ color: item.labelColor }}>{item.value}</span></h3>

              {/* bottom row */}
              <div className={classes.cardFooter}>
                <span style={{ color: item.bottomColor }}>{item.bottomText}</span>
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 35 }} />
     {/* Financial Reports */}
<div className={classes.firstCardDiv}>
  <div className={classes.topText}>
    <div className={classes.leftText}>
      <h3>Financial Reports</h3>
      <p>Core financial statements and analysis</p>
    </div>
    <div className={classes.rightText}>
      <p className={classes.btn}>{financialReports.length} reports</p>
    </div>
  </div>
  <hr className={classes.sectionDivider} />

  <div className={classes.reportFlex}>
    {financialReports.map((report, index) => (
      <div key={index} className={classes.reportCard}>
        <div className={classes.reportHeader}>
          <div className={classes.reportContent}>
            <div className={classes.iconWrapper}>
              <img src={report.icon} alt={report.title} className={classes.icon} />
            </div>
            <div className={classes.textWrapper}>
              <h4>{report.title}</h4>
              <p>{report.description}</p>
            </div>
          </div>
          <span className={classes.tag}>Monthly</span>
        </div>
        <div className={classes.reportActions}>
          <button 
            onClick={() => navigate(report.path)} 
            className={classes.reportBtn}
          >
            Generate Report
          </button>
        </div>
      </div>
    ))}
  </div>
</div>



{/* Sales & Customer Reports */}
{/* Financial Reports */}
<div className={classes.secondCardDiv}>
  <div className={classes.topText}>
    <div className={classes.leftText}>
      <h3>Sales & Customer Reports</h3>
      <p>Track sales performance and customer relationships</p>
    </div>
    <div className={classes.rightText}>
      <p className={classes.btn}>{salesReports.length} reports</p>
    </div>
  </div>
  <hr className={classes.sectionDivider} />

  <div className={classes.reportFlex}>
    {salesReports.map((report, index) => (
      <div key={index} className={classes.reportCard}>
        <div className={classes.reportHeader}>
          <div className={classes.reportContent}>
            <div className={classes.iconWrapper}>
              <img src={report.icon} alt={report.title} className={classes.icon} />
            </div>
            <div className={classes.textWrapper}>
              <h4>{report.title}</h4>
              <p>{report.description}</p>
            </div>
          </div>
          <span className={classes.tag}>Monthly</span>
        </div>
        <div className={classes.reportActions}>
          <button 
            onClick={() => navigate(report.path)} 
            className={classes.reportBtn}
          >
            Generate Report
          </button>
        </div>
      </div>
    ))}
  </div>
</div>



{/* Purchase & Supplier Reports */}
{/* Financial Reports */}
<div className={classes.thirdCardDiv}>
  <div className={classes.topText}>
    <div className={classes.leftText}>
      <h3>Purchase & Supplier Reports</h3>
      <p>Monitor purchasing activities and supplier relationships</p>
    </div>
    <div className={classes.rightText}>
      <p className={classes.btn}>{purchaseReports.length} reports</p>
    </div>
  </div>
  <hr className={classes.sectionDivider} />

  <div className={classes.reportFlex}>
    {purchaseReports.map((report, index) => (
      <div key={index} className={classes.reportCard}>
        <div className={classes.reportHeader}>
          <div className={classes.reportContent}>
            <div className={classes.iconWrapper}>
              <img src={report.icon} alt={report.title} className={classes.icon} />
            </div>
            <div className={classes.textWrapper}>
              <h4>{report.title}</h4>
              <p>{report.description}</p>
            </div>
          </div>
          <span className={classes.tag}>Monthly</span>
        </div>
        <div className={classes.reportActions}>
          <button 
            onClick={() => navigate(report.path)} 
            className={classes.reportBtn}
          >
            Generate Report
          </button>
        </div>
      </div>
    ))}
  </div>
</div>




        </div>
        {loading && (
          <div className={classes.overlay}>
            <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
          </div>
        )}
        {uploading && (
          <div className={classes.overlay}>
            <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
          </div>
        )}
      </div>
      )
}

      export default ReportPage;